export default __webpack_public_path__ + "f9e875b010a48c55e0b7c1e4e399bba6.svg";